import axios from 'axios';
import { useCallback } from 'react';

/**
 * Plain axios, not the configured client from services/apis/config.ts: that one attaches a
 * bearer token, and the destination here is R2, which must never receive the portal's token.
 * The Content-Type must match what the server signed or R2 rejects the PUT.
 */
export const useUpload = () =>
  useCallback(async (url: string, blob: Blob) => {
    await axios.put(url, blob, { headers: { 'Content-Type': blob.type } });
  }, []);
